import { jsx } from 'panel';
import { AsyncButtonEl } from 'common/components/async-button';
import { ButtonTheme } from 'common/components/button/constants';
import { SpinnerEl } from 'common/components/spinner';
import { SwitchEl } from 'common/components/switch';
export function template() {
  return jsx("div", {
    sel: '.cookie-center'
  }, jsx("div", {
    sel: '.header'
  }, " Mixpanel's website uses cookies "), jsx("div", {
    sel: '.description'
  }, "Some of these cookies are necessary for our site to function, and some improve the functioning and performance of our site. You can learn more about our use of cookies in our ", jsx("a", null, "Cookie Policy"), "."), jsx("div", {
    sel: '.divider'
  }), jsx("div", {
    sel: '.subheader'
  }, " Necessary Cookies "), jsx("div", {
    sel: '.description'
  }, "These cookies are essential for our site to function. They remain active at all times and cannot be switched off in our systems because they are required to deliver security and the core functionalities (including consent preferences) so you can navigate, and reliably use our site. List of ", jsx("a", null, "Necessary Cookies.")), jsx("div", {
    sel: '.divider'
  }), jsx("div", {
    sel: '.toggle-header'
  }, jsx("div", {
    sel: '.subheader'
  }, " Optional Cookies "), jsx("div", {
    sel: '.toggle-section'
  }, this.state.optCookies === null ? jsx(SpinnerEl, null) : jsx(SwitchEl, {
    attrs: {
      on: this.state.optCookies
    },
    on: {
      change: this.helpers.handleSwitchChange
    }
  }))), jsx("div", {
    sel: '.description'
  }, "These cookies are not necessary for the site to function."), jsx("div", {
    sel: '.button-wrapper'
  }, jsx(AsyncButtonEl, {
    attrs: {
      theme: ButtonTheme.Primary,
      'style-override': "",
      disabled: this.state.optCookies === null
    },
    props: {
      asyncAction: this.helpers.handleSave
    }
  }, "Save Settings")));
}